import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from './storage';
import type { PropertyCreateFormData } from '@/schema/properties';

interface PropertyCreateState {
  formData: Partial<PropertyCreateFormData>;
}

const initialState: PropertyCreateState = {
  formData: {},
};

const slice = createSlice({
  name: 'propertyCreate',
  initialState,
  reducers: {
    setFormPartial: (
      state,
      action: PayloadAction<Partial<PropertyCreateFormData>>
    ) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setFormFull: (state, action: PayloadAction<PropertyCreateFormData>) => {
      state.formData = action.payload;
    },
    clearForm: state => {
      state.formData = {};
    },
  },
});

export const { setFormPartial, setFormFull, clearForm } = slice.actions;

const persistConfig = {
  key: 'propertyCreate',
  storage,
  whitelist: ['formData'],
};

export const propertyCreateReducer = persistReducer(
  persistConfig,
  slice.reducer
);
export default slice.reducer;
